import { z } from 'zod';
import { idSchema, isoDateSchema, seasonLabelSchema, varietyCodeSchema, weekNumberSchema, } from './common.js';
/** A production unit. Growers see the name; the PUC is the pack-house reference. */
export const farmSchema = z.object({
    id: idSchema,
    name: z.string().min(1),
    puc: z.string().min(1),
    active: z.boolean(),
});
export const varietySchema = z.object({
    code: varietyCodeSchema,
    name: z.string().min(1),
    active: z.boolean(),
});
export const seasonSchema = z.object({
    id: idSchema,
    label: seasonLabelSchema,
    /** First Monday of the season. */
    startDate: isoDateSchema,
    /** Last Saturday of the season. */
    endDate: isoDateSchema,
    active: z.boolean(),
});
/** Everything the PWA needs to work offline for a grower, fetched once after sign-in and refreshed. */
export const masterDataSchema = z.object({
    farms: z.array(farmSchema),
    varieties: z.array(varietySchema),
    seasons: z.array(seasonSchema),
    /**
     * Which varieties are in harvest in which week, for the active seasons. Capture offers the
     * week's varieties rather than all of them, so every role needs this, not just admins.
     */
    harvestWeeks: z.array(z.object({
        seasonId: idSchema,
        varietyCode: varietyCodeSchema,
        weekNumber: weekNumberSchema,
    })),
    /** Server time when this snapshot was produced. Lets the client show how fresh it is. */
    fetchedAt: z.iso.datetime({ offset: true }),
});
//# sourceMappingURL=masterData.js.map